
// depLocation is dependency location for testing cases
export const switchENV = (envUrl, depLocation) => {
    const location = depLocation || document.location.origin;
    const production = import.meta.env.MODE === 'production';
    const staging = import.meta.env.MODE === 'staging';
    const development = import.meta.env.MODE === 'development'
    const envList = import.meta.env;
    const extLocalhost = 'http://localhost.troweprice.com:3000'
    const intLocalhost = 'http://localhost.awstrp.net:3000'
    if (!production && !import.meta.env.TEST) {
        console.log(envList)
    }
    if (production || staging || development) {
        switch (location) {
            case import.meta.env.VITE_EXTERNAL_DEV:
                return envUrl.dev;

            case extLocalhost:
            case intLocalhost:
                return envUrl.dev

            case import.meta.env.VITE_INTERNAL_DEV:
                return envUrl.dev;

            case import.meta.env.VITE_EXTERNAL_STAGE:
                return envUrl.stage;

            case import.meta.env.VITE_INTERNAL_STAGE:
                return envUrl.stage;

            case import.meta.env.VITE_EXTERNAL_PROD:
                return envUrl.prod;

            case import.meta.env.VITE_INTERNAL_PROD:
                return envUrl.prod;

            default:
                return envUrl.prod;
        }
    }
    else {
        return envUrl.prod;
    }
};


export const externalLinkEnvUrl = {
    dev: 'https://wwwdev.troweprice.com',
    stage: 'https://wwwstage.troweprice.com',
    prod: 'https://www.troweprice.com'
};

export const internalLinkEnvUrl = {
    dev: 'https://wwwdev.awstrp.net',
    stage: 'https://wwwstage.awstrp.net',
    prod: 'https://www.awstrp.net'
};

export const externalEnvUrl = {
    dev: 'https://www3dev.troweprice.com',
    stage: 'https://www3qual.troweprice.com/',
    prod: 'https://www3.troweprice.com'
};

// override allows forcing use of the internal/external domain
const switchEnvUrl = (path, override) => {
    if (override && override === 'internal') {
        return switchENV(internalLinkEnvUrl) + path;
    }
    return switchENV(externalLinkEnvUrl) + path;
}

export const mgpSsoDevLink =
    'https://dev.moneyguidepro.com/troweprice/SsoSamlNoRef.aspx?IntegrationId=186';

const internalLocal = '.awstrp.net'

export const apiEnvUrl = window.location.hostname.toLowerCase().indexOf(internalLocal) !== -1 ?
    {
        dev: 'https://api.dev.awstrp.net',
        stage: 'https://api.stage.awstrp.net',
        prod: 'https://api.prod.awstrp.net'
    } :
    {
        dev: 'https://api.dev.troweprice.com',
        stage: 'https://api.confidence.troweprice.com',
        prod: 'https://api.public.troweprice.com'
    };

// AEM Pages
export const aemPageLinks = {
    faqLink: switchEnvUrl('/personal-investing/advice/retirement-advisory-service/faq.html'),
    learnMoreLink: switchEnvUrl('/personal-investing/planning-and-research/advice/planning-service/implementation-guide.html')
}

// AEM PDFs
export const aemPdfLinks = {
    aggregationServiceTermsLink: switchEnvUrl(`/content/dam/iinvestor/products-and-services/adv/Aggregation-Services-Terms.pdf`),
    formADVLink: switchEnvUrl('/content/dam/iinvestor/advice/retirement-advisory-service/t-rowe-price-retirement-advisory-service-form-adv.pdf'),
    fpsClientAgreementLink: switchEnvUrl('/content/dam/iinvestor/advice/retirement-advisory-service/t-rowe-price-finanical-planning-client-agreement-and-supplement.pdf'),
    advisoryServicesCrs: switchEnvUrl('/content/dam/iinvestor/Forms/trpas-form-crs.pdf'),
    investmentServicesCrs: switchEnvUrl('/content/dam/iinvestor/Forms/trpis-form-crs.pdf'),
    PrivacyNoticeUSCAN: switchEnvUrl('/enterprise/legal/us/en/privacy-notices.html')

};

export const accountCenter = switchEnvUrl('/usis/my-accounts/external-account-center')

export const prospYodleeIframeUrl = switchEnvUrl('/usis/advice/fps/yodlee-link-account');

export const FPSClientAgreement =
    [
        {
            id: '1',
            name: 'Client Agreement and Planning Supplement',
            agreementLink: aemPdfLinks.fpsClientAgreementLink,
            linkId: 'fps-client-agreement-pdf',
            showPdfIcon: true
        },
        {
            id: '2',
            name: 'Retirement Advisory Service Form ADV',
            agreementLink: aemPdfLinks.formADVLink,
            linkId: 'fps-adv-form-pdf',
            showPdfIcon: true
        },
        {
            id: '3',
            name: 'TRP Advisory Services Form CRS',
            agreementLink: aemPdfLinks.advisoryServicesCrs,
            linkId: 'advisory-services-crs-pdf',
            showPdfIcon: true
        },
        {
            id: '4',
            name: 'TRP Investment Services Form CRS',
            agreementLink: aemPdfLinks.investmentServicesCrs,
            linkId: 'investment-services-crs-pdf',
            showPdfIcon: true
        },
        {
            id: '5',
            name: 'T. Rowe Price Privacy Notice (U.S. & Canada)',
            agreementLink: aemPdfLinks.PrivacyNoticeUSCAN,
            linkId: 'privacy-notice-USCAN-pdf',
            showPdfIcon: true
        }
    ]


export const adviceProspectusBaseUrl =
    'https://prospectus-express.broadridge.com/summary.asp?doctype=pros&clientid=trowepll&fundid=';

export const rasUrl = switchEnvUrl('/usis/advice/checkout/hub', document.location.origin.includes(internalLocal) ? 'internal' : undefined);
export const expressUrl = switchEnvUrl('/usis/advice/enrollment', document.location.origin.includes(internalLocal) ? 'internal' : undefined);

const logOutPath = '/usis/login/logout?sdurl=';
const logoutSdurl = '/usis/my-accounts/post-logout'


export const aamUrl = switchEnvUrl('/usis/my-accounts', document.location.origin.includes(internalLocal) ? 'internal' : undefined);
export const transferPage = switchEnvUrl('/usis/advice/checkout/transfer', document.location.origin.includes(internalLocal) ? 'internal' : undefined)
export const advisorHubPage = switchEnvUrl(`/usis/advice/admin-tool/advisor-hub?delegateUser=${sessionStorage.getItem("delegateUserId")}`,
    document.location.origin.includes(internalLocal) ? 'internal' : undefined)

export const footerProspectus = 'https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html';
export const footerETF = 'https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html';

// Session Timeout logout urls
export const logoutUrl = switchENV(externalLinkEnvUrl) + logOutPath + switchENV(externalLinkEnvUrl) + logoutSdurl;
